import {CLIssueLevel, CLIssueName} from './issues.types';

export const IssueLevelToIssueName: Record<CLIssueLevel, CLIssueName> = {
  [CLIssueLevel.Error]: CLIssueName.Error,
  [CLIssueLevel.Warning]: CLIssueName.Warning,
  [CLIssueLevel.Info]: CLIssueName.Info,
  [CLIssueLevel.Success]: CLIssueName.Success,
};
